"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollExternalLink = exports.scroll = void 0;
/* ========================================================================
    Module: Scroll
 ========================================================================== */
const uikit_1 = __importDefault(require("uikit"));
const util_1 = require("~modules/util");
const breakpointLarge = (0, util_1.getCssPropertyValue)("--uk-breakpoint-l");
/**
 * スクロールを設定する
 *
 * @returns void
 */
const scroll = () => {
    const scrollSelector = ".js-scroll";
    const options = {
        offset: parseInt((0, util_1.getCssPropertyValue)("--project-header-height-s")),
    };
    if (window.matchMedia(`(min-width: ${breakpointLarge})`).matches) {
        options.offset = parseInt((0, util_1.getCssPropertyValue)("--project-header-height-m"));
    }
    uikit_1.default.scroll(scrollSelector, options);
};
exports.scroll = scroll;
/**
 * In-page link scrolling from external links
 *
 * @returns void
 */
const scrollExternalLink = () => {
    const headerElement = document.querySelector(".js-header");
    const fragment = location.hash;
    if (fragment && headerElement) {
        const target = document.querySelector(fragment);
        if (target) {
            const targetOffsetTop = target.offsetTop;
            document.documentElement.scrollTop = targetOffsetTop;
            setTimeout(() => {
                document.documentElement.scrollTop =
                    targetOffsetTop - headerElement.offsetHeight;
            }, 200);
        }
    }
};
exports.scrollExternalLink = scrollExternalLink;
